'use client';

import React, { useState } from 'react';
import { ComponentNode } from '../types/template';
import { convertStylesToInline } from '../utils/styleUtils';
import { getNestedValue } from '../utils/dataBinding';
import OfferDetailModal from './OfferDetailModal';

interface ProductDetailTriggerProps {
    component: ComponentNode;
    data?: any;
    context?: {
        domain?: string;
        store_slug?: string;
        slug_type?: string;
        category_slug?: string;
        promotion_slug?: string;
        out_link?: string;
    };
}

const ProductDetailTrigger: React.FC<ProductDetailTriggerProps> = ({ component, data, context }) => {
    const [isOpen, setIsOpen] = useState(false);
    const { data: componentData, placeholder, styles, type, customClassName } = component;
    const inlineStyles = convertStylesToInline(styles);

    // `""` means "bind to the item itself" (see getNestedValue); only a
    // genuinely absent placeholder skips the lookup.
    const dynamicValue = placeholder !== undefined ? getNestedValue(data, placeholder) : undefined;
    const label =
        typeof dynamicValue === 'string'
            ? dynamicValue.trim() || componentData
            : dynamicValue ?? componentData;

    const trigger = type === 'BUTTON' ? (
        <button
            type="button"
            onClick={() => setIsOpen(true)}
            style={inlineStyles}
            className={[customClassName, 'px-4 py-2 rounded-full font-medium hover:opacity-90 transition-opacity'].filter(Boolean).join(' ')}
        >
            {label}
        </button>
    ) : (
        <span
            role="button"
            tabIndex={0}
            onClick={() => setIsOpen(true)}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') setIsOpen(true); }}
            style={{ ...inlineStyles, cursor: 'pointer' }}
            className={customClassName}
        >
            {label}
        </span>
    );

    return (
        <>
            {trigger}
            {isOpen && <OfferDetailModal data={data} context={context} onClose={() => setIsOpen(false)} />}
        </>
    );
};

export default ProductDetailTrigger;
